export default "__VITE_ASSET__a4f0177a__"